module.exports = __webpack_public_path__ + "static/media/26UNRWA2.128e770a.jpg";